export default __webpack_public_path__ + "static/media/chrome-phone-apple-3.02718071.png";